export default {
  attendance: {},
  guichesPanel: [],
  currentPasswords: [],
};
